import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ModalController } from '@ionic/angular';
import { CariHesapEkstresiFilter, ICariHesapEkstresi } from '@models/finance';
import { FinanceService } from '@services/apis/finance.service';
import { RootModalComponent } from '@shared/components/root-modal/root-modal.component';
import { format } from 'date-fns';
import { CariHesapEkstresiFilterComponent } from '../cari-hesap-ekstresi-filter/cari-hesap-ekstresi-filter.component';

@Component({
  selector: 'app-cari-hesap-ekstresi',
  templateUrl: './cari-hesap-ekstresi.component.html',
  styleUrls: ['./cari-hesap-ekstresi.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CariHesapEkstresiComponent implements OnInit {
  @Input() rootModal: boolean;
  
  public cariHesapEkstresi: ICariHesapEkstresi[];
  public tumCariHesapEkstresi: ICariHesapEkstresi[];
  public cariHesapEkstresiFilter: CariHesapEkstresiFilter;

  constructor(
    public app: AppService,
    private modalController: ModalController,
    private financeService: FinanceService,
    private statusBar: StatusBar,
  ) {
    this.cariHesapEkstresiFilter = new CariHesapEkstresiFilter();
  }

  ngOnInit(): void {
    this.getCariHesapEkstresi();
  }

  getCariHesapEkstresi() {
    this.financeService.getCariHesapEkstresi$().subscribe(response => {
      this.cariHesapEkstresi = response;
      this.tumCariHesapEkstresi = this.cariHesapEkstresi;
    });
  }

  async filter() {
    const modal = await this.modalController.create({
      component: RootModalComponent,
      presentingElement: await this.modalController.getTop(),
      componentProps: {
        rootPage: CariHesapEkstresiFilterComponent,
        cariHesapEkstresiFilter: this.cariHesapEkstresiFilter
      }
    });
    modal.onDidDismiss().then(async (dismissResult) => {
      const selectedData = dismissResult.data;
      if (selectedData.dismissed) {
        const _baslangicTarihi = format(new Date(selectedData.baslangicTarihi), 'dd.MM.yyyy');
        const _bitisTarihi = format(new Date(selectedData.bitisTarihi), 'dd.MM.yyyy');
        if (selectedData.baslangicTarihi) {
          this.cariHesapEkstresi = this.tumCariHesapEkstresi.filter((x) =>
            format(new Date(x.tarih), 'dd.MM.yyyy') >= _baslangicTarihi && format(new Date(x.tarih), 'dd.MM.yyyy') <= _bitisTarihi);
        } else {
          this.cariHesapEkstresi = this.tumCariHesapEkstresi;
        }
      }
      this.statusBar.styleLightContent();
    });
    return await modal.present();
  }

  async dismiss(dismissed: boolean) {
    await this.modalController.dismiss(dismissed);
  }
}
